"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card1;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Card1(props) {
  const [listItems, setListItems] = (0, _react.useState)(props.list || []);
  (0, _react.useEffect)(() => {
    var _props$list;

    if (props.maxItems && props !== null && props !== void 0 && (_props$list = props.list) !== null && _props$list !== void 0 && _props$list.length) {
      setListItems(props.list.slice(0, props.maxItems));
    } else {
      setListItems(props.list || []);
    }
  }, [props.maxItems, props.list]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "users_list",
    className: "flex flex-wrap list-card-main-container"
  }, !!listItems && (listItems === null || listItems === void 0 ? void 0 : listItems.map((item, index) => {
    var _item$feedback, _item$image, _item$user_name, _item$user_designatio, _item$user_designatio2;

    return /*#__PURE__*/_react.default.createElement("div", {
      id: item.id,
      key: index,
      className: "list-card w-100-l flex flex-column justify-between relative"
    }, item !== null && item !== void 0 && (_item$feedback = item.feedback) !== null && _item$feedback !== void 0 && _item$feedback.display_text ? /*#__PURE__*/_react.default.createElement("p", {
      id: item.id + "_" + "feedback",
      className: "mt0 mb4 f6"
    }, item === null || item === void 0 ? void 0 : item.feedback.display_text) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex items-center"
    }, item !== null && item !== void 0 && (_item$image = item.image) !== null && _item$image !== void 0 && _item$image.url ? /*#__PURE__*/_react.default.createElement("img", {
      id: item.id + "_" + "image",
      src: item.image.url,
      className: "card-image"
    }) : null, /*#__PURE__*/_react.default.createElement("div", null, item !== null && item !== void 0 && (_item$user_name = item.user_name) !== null && _item$user_name !== void 0 && _item$user_name.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "name",
      className: "f5 b pb1"
    }, item === null || item === void 0 ? void 0 : item.user_name.display_text) : null, item !== null && item !== void 0 && (_item$user_designatio = item.user_designation) !== null && _item$user_designatio !== void 0 && _item$user_designatio.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "designation",
      className: "mid-gray f7 tl"
    }, item === null || item === void 0 ? void 0 : (_item$user_designatio2 = item.user_designation) === null || _item$user_designatio2 === void 0 ? void 0 : _item$user_designatio2.display_text) : null)), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex flex-column justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: ""
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/blackedit.png"
    }), "Edit"), /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: "",
        operation: "delete"
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove")));
  })), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-card flex flex-column items-center justify-center pointer",
    onClick: () => props.onWrapperClick({
      parentKey: "users_list",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "plus-sign"
  }, "+"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, "Add New")));
}